import AuthenticatedController from './AuthenticatedController';
import { buildQueryString } from '@mm/utils';
import * as APIRoutes from '@mm/api-routes';
import { AdCampaignModel } from '../model/AdCampaignModel';

type AdCampaignsResponse = {
  adCampaigns: AdCampaignModel[];
  pagination: {
    isLastPage: boolean;
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
  };
};

export default class AdCampaignController extends AuthenticatedController {
  static async retrieveMessagesCampaigns(
    fbPageId: number,
    adAccountId: string,
    remote: boolean,
    page: number = 1,
    perPage: number = 100,
  ): Promise<AdCampaignsResponse> {
    const queryString = buildQueryString({
      facebook_page_id: fbPageId,
      ad_account_id: adAccountId,
      per_page: perPage,
      page,
      remote,
    });

    const url = APIRoutes.MESSAGES_AD_CAMPAIGNS(queryString);
    return super.get(url);
  }
}
